import { gql } from '@apollo/client'

export const MAKE_ADMISSION_REQUEST = gql`
  mutation MakeAdmissionRequest($input: AdmissionRequestInput!) {
    makeAdmissionRequest(input: $input)
  }
`
